import React, { useEffect, useState, useRef } from 'react';
import { toast } from 'react-toastify';
import MensajeChat from './mensaje';
import ContenidoEnriquecido from '../../components/ContenidoEnriquecido';
import { formMensajeInicial } from '../../objetos/Chat/objeto_chat';
import { MessageSquare , Send, CheckCircle2, Lock } from 'lucide-react';
import { useRetornoAsesor } from '../../config/unificacion';

const ListaChat = ({ 
  mensajes = [], 
  onEnviarMensaje, 
  codigo, 
  isAdmin,
  resuelto = false,
}) => {
  const [nuevoMensaje, setNuevoMensajes] = useState(formMensajeInicial);
  const scrollRef = useRef(null);
  const { retornoAsesor } = useRetornoAsesor();
  const cambiadopor = retornoAsesor();

  // Scroll automático al final
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [mensajes]);
  
  const handleSaveContenido = (nuevoContenido) => {
    setNuevoMensajes(prev => ({ ...prev, mensaje: nuevoContenido }));
  };

  const handleEnviar = (e) => {
    e.preventDefault();

    if (!nuevoMensaje.mensaje || nuevoMensaje.mensaje === "" || nuevoMensaje.mensaje === "<p></p>") {
      toast.warn("El mensaje está vacío.");
      return;
    }

    // Inyectar datos con TIMESTAMP en ID
    const payload = {
      ...nuevoMensaje,
      asesor: cambiadopor,
      fecha: new Date(),
      id: `${codigo}-${Date.now()}`, // Genera ID único por milisegundo
      isAdmin: isAdmin
    };

    if (onEnviarMensaje) onEnviarMensaje(payload);
    setNuevoMensajes(formMensajeInicial);
  };

  return (
    <div className="flex flex-col h-[85vh] w-full bg-white rounded-3xl border border-gray-100 shadow-2xl overflow-hidden">
      
      {/* 1. HEADER */}
      <div className="py-4 px-6 border-b border-gray-100 bg-gray-50 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className={`p-2 rounded-lg shadow-lg ${resuelto ? 'bg-slate-400' : 'bg-blue-600'}`}>
            <MessageSquare size={20} className="text-white" />
          </div>
          <div>
            <h3 className="text-xl font-black text-gray-800 tracking-tighter uppercase leading-none">
                Historial de Revisión
            </h3>
            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-1">
                {resuelto ? "Comunicación Finalizada" : "Comunicación Técnica"}
            </p>
          </div>
        </div>
        {resuelto && (
            <div className="flex items-center gap-2 px-3 py-1 bg-green-50 border border-green-200 rounded-full">
                <CheckCircle2 size={12} className="text-green-600" />
                <span className="text-[10px] font-black text-green-700 uppercase">Resuelto</span>
            </div>
        )}
      </div>

      {/* 2. AREA DE MENSAJES (Aumentada y con espaciado optimizado) */}
      <div 
        ref={scrollRef}
        className="flex-1 overflow-y-auto p-6 md:p-10 bg-white space-y-4 scroll-smooth"
      >
        {mensajes.length > 0 ? (
          mensajes.map((msg, index) => (
            <MensajeChat 
              key={msg.id || index} 
              data={msg}
              viewerIsAdmin={isAdmin}
            />
          ))
        ) : (
          <div className="h-full flex flex-col items-center justify-center opacity-30 italic">
            <p className="text-sm font-medium">No hay mensajes aún.</p>
          </div>
        )}
      </div>

      {/* 3. FOOTER CONDICIONAL */}
      <div className={`p-6 border-t border-gray-100 ${resuelto ? 'bg-slate-100' : 'bg-gray-50'}`}>
        
        {resuelto ? (
          /* VISTA CASO CERRADO */
          <div className="flex flex-col items-center justify-center py-6 animate-in fade-in zoom-in duration-500">
            <div className="p-4 bg-white rounded-full shadow-sm mb-3 text-slate-400">
                <Lock size={24} />
            </div>
            <h4 className="text-sm font-black text-slate-500 uppercase tracking-tighter">
                Chat Finalizado
            </h4>
            <p className="text-[10px] text-slate-400 font-bold uppercase mt-1">
                Este caso ha sido marcado como resuelto y no admite más interacciones.
            </p>
          </div>
        ) : (
          /* VISTA CHAT ACTIVO */
          <div className="flex flex-col gap-4">
            <div className="bg-white rounded-2xl border border-gray-200 shadow-inner">
                <ContenidoEnriquecido 
                    key={mensajes.length} 
                    contenido={nuevoMensaje.mensaje} 
                    isAdmin={true}
                    editable={true}
                    onSave={handleSaveContenido}
                />
            </div>

            <div className="flex justify-between items-center px-2">
                <div className="text-[10px] font-black uppercase text-gray-400">
                    {nuevoMensaje.mensaje ? "✅ Borrador listo" : "📝 Escribe una instrucción"}
                </div>

                <button
                    onClick={handleEnviar}
                    className={`flex items-center gap-3 px-12 py-4 rounded-2xl font-black transition-all shadow-lg ${
                        nuevoMensaje.mensaje 
                        ? 'bg-blue-600 text-white hover:bg-blue-700 active:scale-95' 
                        : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                    }`}
                >
                    <span>ENVIAR MENSAJE</span>
                    <Send size={18} />
                </button>
            </div>
          </div>
        )}
      </div>

    </div>
  );
};

export default ListaChat;